export { CompletedSubscriptionsScreen as default } from '@/src/features/prayer-space/ui/screens/CompletedSubscriptionsScreen'
